import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import Collapse from 'antd/es/collapse';
import Modal from 'antd/es/modal';
import Dropdown from 'antd/es/dropdown';
import Menu from 'antd/es/menu';
import Spin from 'antd/es/spin';

import WorkingHoursService from 'services/workingHours';

import { Row, Col } from 'components/layout';
import { Title } from 'components/Text';
import Button from 'components/Button';
import Icon from 'components/Icon';

import ScheduleCalendar from '../components/ScheduleCalendar';

import { formatDate } from 'helpers/date';

import { dataToShifts } from '../helpers';

// styles
import '../styles/fullCalendar.css';
import { dateMonthDayFormat } from 'config/common';

const workingHoursService = new WorkingHoursService();

const WorkingHoursTab = () => {
  const history = useHistory();
  // const workingHours = useModel(workingHoursModel);
  const [isLoading, setIsLoading] = useState(false);
  const [periods, setPeriods] = useState([]);
  const [activeKey, setActiveKey] = useState('');

  useEffect(() => {
    setIsLoading(true);
    workingHoursService.list()
      .then(data => {
        if (!data) return;
        setPeriods(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
  }, []);

  return (
    <Row justify="center">
      <Col style={{ width: '96%' }}>
        <Title
          level={4}
          style={{
            textAlign: 'center',
            marginBottom: '32px'
          }}
        >
          Working Hours
        </Title>

        <PeriodsCollapse
          accordion={true}
          destroyInactivePanel={true}
          onChange={(schedule_id) => {
            if (schedule_id) {
              setActiveKey(schedule_id);
              setIsLoading(true);
              workingHoursService.listShifts({ schedule_id })
                .then(shiftsData => {
                  if (!shiftsData) return;
                  const periodShifts = dataToShifts(shiftsData);
                  setPeriods(periods => periods.map(period => {
                    if (period.id.toString() === schedule_id) {
                      period.shifts = periodShifts;
                    }
                    return period;
                  }));
                })
                .finally(() => {
                  setIsLoading(false);
                });
            }
          }}
        >
          {
            periods.map((period) => {
              const fromDt = new Date(period.valid_from);
              const toDt = period.valid_to ? new Date(period.valid_to) : null;
              const header = [
                formatDate(fromDt, `${dateMonthDayFormat} yyyy`),
                toDt ? formatDate(toDt, `${dateMonthDayFormat} yyyy`) : '...',
              ].join(' - ');

              return (
                <Collapse.Panel
                  key={period.id}
                  header={header}
                  extra={
                    <Dropdown
                      trigger={'click'}
                      onClick={e => e.stopPropagation()}
                      overlay={(
                        <Menu onClick={e => {
                          e.domEvent.stopPropagation();
                          switch (e.key) {
                            case 'edit':
                              history.push(`/settings/schedule/${period.id}`);
                            break;
                            case 'delete':
                              Modal.confirm({
                                content: 'Are sure you want to delete this schedule?',
                                onOk: () => {
                                  workingHoursService.delete({ schedule_id: period.id })
                                    .then(() => {
                                      setPeriods(periods => periods.filter(p => p.id !== period.id))
                                    });
                                }
                              });
                            break;
                            default:
                              // make eslint happy :)
                          }
                        }}>
                          <Menu.Item key={'edit'}>
                            <Icon name="edit-2" color="#828C94" size={16} />
                            Edit Schedule
                          </Menu.Item>
                          <Menu.Item key={'delete'} style={{ color: '#F5222D' }}>
                            <Icon name="trash-2" color="#F5222D" size={16} />
                            Delete Schedule
                          </Menu.Item>
                        </Menu>
                      )}
                    >
                      <Icon name="settings" color="#828C94" size={16} />
                    </Dropdown>
                  }
                >
                  {isLoading ? (
                    <Spin
                      size={30}
                      style={{ width: '100%', padding: '48px' }}
                    />
                  ) : (activeKey === period.id.toString()) ? (
                    <ScheduleCalendar
                      editable={false}
                      selectable={false}
                      shifts={period.shifts}
                      dayShiftBgColor="#42B0D5"
                      nightShiftBgColor="#1D678A"
                    />
                  ) : null}
                </Collapse.Panel>
              );
            })
          }
        </PeriodsCollapse>

        <Row style={{ padding: '16px 0' }}>
          <Button
            icon={{
              name: 'plus',
              size: 14,
            }}
            onClick={() => {
              history.push('/settings/schedule')
            }}
          >
            Add schedule
          </Button>
        </Row>
      </Col>
    </Row>
  );
};

const PeriodsCollapse = styled(Collapse)`
  width: 100%;
  margin: auto;

  & .ant-list-split .ant-list-item:last-child { 
    border-bottom: 1px solid #f0f0f0;
  }

  & .ant-collapse-content {
    padding: 0;
    & > .ant-collapse-content-box {
      padding: 24px;
    }
  }
`;

export default WorkingHoursTab;
